import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amazon-attribution-details',
  templateUrl: './help-amazon-attribution-details.component.html'
})
export class HelpAmazonAttributionDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
